export class PagingDTO{
    constructor(){

    }
      TotalCount:number=0
      PageCount:number=10
      CurrentPageNumber:number=1
      IsFilterUpdated:boolean=false
      Skip:number=0
      Take:number=0
      DevMode:boolean=true
      AddedItemsCount:number=0
}